<template>
  <section>
    <div class="row">
      <div class="col-md-6">
        <z-input
          v-model="name"
          name="name"
          label="Name"
          validate="required"
          @keyup="saveIt"
        />
      </div>
      <div class="col-md-6">
        <input
          type="checkbox"
          id="isOpen"
          v-model="closed"
          class="z-checkbox-small"
          tabindex="-1"
          @click="saveIt"
        />
        <label for="isOpen" class="custom-open">Open?</label>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <z-textarea
          v-model="description"
          name="description"
          label="Description"
          :rows="5"
          :maxlength="10000"
          @keyup="saveIt"
        />
      </div>
      <div class="col-md-6"></div>
    </div>
    <div class="row mt-2">
      <div class="col-md-3">
        <z-input
          v-model="start_date"
          name="start_date"
          label="Start (must start on a Monday)"
          type="date"
          @change="saveIt"
        />
      </div>
      <div class="col-md-3">
        <z-input
          v-model="visible_date"
          name="visible_date"
          label="Visible On (before Start date)"
          type="date"
          @change="saveIt"
        />
      </div>
      <div class="col-md-2">
        <z-input
          v-model="numWeeks"
          label="# weeks"
          type="Number"
          min="0"
          @change="saveIt"
          @keyup="saveIt"
        />
      </div>
      <div class="col-md-3">
        <z-input
          v-model="end_date"
          name="end_date"
          label="End Date (on a Monday)"
          type="date"
          @change="saveIt"
        />
      </div>
      <div class="col-md-1"></div>
    </div>
    <div class="row mt-2">
      <div class="col-md-12">
        <div v-if="isShowActions" class="input-group">
          <span class="input-group-text custom-weekof">for the week of</span>
          <select
            v-model="week"
            class="form-select custom-select"
            @change="changeWeek('select')"
          >
            <option v-for="(week, idx) of weeks" :key="idx">
              {{ week.short }}
            </option>
          </select>
          <button class="btn btn-warning btn-sm" @click="recalculate">
            Recalculate
          </button>
          <button class="btn btn-info btn-sm" @click="generateReport">
            Generate Report
          </button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import ZInput from '@/Components/ZElements/Input'
import ZSelect from '@/Components/ZElements/Select'
import ZTextarea from '@/Components/ZElements/TextArea'
export default {
  name: 'challenge',
  components: {
    ZInput,
    ZSelect,
    ZTextarea,
  },
  data() {
    return {
      currentWeek: null,
    }
  },
  emits: ['saveIt', 'recalculated'],
  mounted() {
    this.currentWeek = moment().startOf('week').format('YYYY-MM-DD')
    console.log('Mounted: Current Week', {
      summary: this.summary,
      current: this.currentWeek,
    })
  },
  computed: {
    ...mapGetters('challenges', ['challenge']),
    ...mapGetters('usercardio', ['summary']),
    weeks() {
      let _data = []
      if (this.summary) {
        _data = this.summary.weeks
      }
      console.log('set up weeks', _data)
      return _data
    },
    week: {
      get() {
        let _data = ''
        if (this.summary) {
          _data = this.summary.week.name
        }
        console.log('current selected week', this.summary.week)
        return _data
      },
      set(value) {
        this.setWeek(value)
      },
    },
    isShowActions() {
      return this.id !== undefined && this.id !== null ? true : false
    },
    id() {
      let _data = null
      if (this.challenge) {
        _data = this.challenge.id
      }
      return _data
    },
    name: {
      get() {
        let _data = ''
        if (this.challenge) {
          _data = this.challenge.name
        }
        return _data
      },
      set(value) {
        this.setChallengeData({
          name: 'name',
          value: value,
        })
      },
    },
    description: {
      get() {
        let _data = ''
        if (this.challenge) {
          _data = this.challenge.description
        }
        return _data
      },
      set(value) {
        this.setChallengeData({
          name: 'description',
          value: value,
        })
      },
    },
    start_date: {
      get() {
        let _data = null
        if (this.challenge) {
          _data = moment
            .utc(new Date(this.challenge.start_date))
            .startOf('week')
            .add(1, 'days')
            .format('YYYY-MM-DD')
        }
        return _data
      },
      set(value) {
        let _numWeeks = this.numWeeks
        let _start = moment.utc(new Date(value)).startOf('week').add(1, 'days')
        console.log('start: New Start Date', {
          moment: _start,
          formatted: _start.format('YYYY-MM-DD') + ' 00:00:00',
        })
        this.setChallengeData({
          name: 'start_date',
          value: _start.format('YYYY-MM-DD') + ' 00:00:00',
        })
        let _end = _start.add(_numWeeks, 'week').startOf('week').add(1, 'days')
        console.log('start: New End Date', {
          numWeeks: _numWeeks,
          moment: _end,
          formatted: _end.format('YYYY-MM-DD') + ' 00:00:00',
        })
        this.setChallengeData({
          name: 'end_date',
          value: _end.format('YYYY-MM-DD') + ' 00:00:00',
        })
        this.$nextTick(() => {
          window.app.$forceUpdate()
        })
      },
    },
    numWeeks: {
      get() {
        let _data = null
        if (this.challenge) {
          let _start = moment.utc(new Date(this.challenge.start_date))
          let _end = moment.utc(new Date(this.challenge.end_date))
          let diff = _end.diff(_start, 'week', true)
          _data = parseInt(Math.round(diff))
        }
        return _data
      },
      set(value) {
        // calculate the End Date
        let _start = moment.utc(new Date(this.challenge.start_date))
        let _end = _start.add(value, 'week').startOf('week').add(1, 'days')
        console.log('# weeks: New End Date', {
          moment: _end,
          formatted: _end.format('YYYY-MM-DD') + ' 00:00:00',
        })
        this.setChallengeData({
          name: 'end_date',
          value: _end.format('YYYY-MM-DD') + ' 00:00:00',
        })
        this.$nextTick(() => {
          window.app.$forceUpdate()
        })
      },
    },
    end_date: {
      get() {
        let _data = null
        if (this.challenge) {
          _data = moment
            .utc(new Date(this.challenge.end_date))
            .startOf('week')
            .add(1, 'days')
            .format('YYYY-MM-DD')
        }
        return _data
      },
      set(value) {
        let _end = moment.utc(new Date(value)).startOf('week').add(1, 'days')
        console.log('end: New End Date', {
          moment: _end,
          formatted: _end.format('YYYY-MM-DD') + ' 00:00:00',
        })
        this.setChallengeData({
          name: 'end_date',
          value: _end.format('YYYY-MM-DD') + ' 00:00:00',
        })
        this.$nextTick(() => {
          window.app.$forceUpdate()
        })
      },
    },
    visible_date: {
      get() {
        let _data = null
        if (this.challenge) {
          _data = moment
            .utc(new Date(this.challenge.visible_date))
            .format('YYYY-MM-DD')
        }
        return _data
      },
      set(value) {
        this.setChallengeData({
          name: 'visible_date',
          value: moment.utc(new Date(value)).format('YYYY-MM-DD') + ' 00:00:00',
        })
        window.app.$forceUpdate()
      },
    },
    closed: {
      get() {
        let _data = false
        if (this.challenge) {
          _data = this.challenge.closed
        }
        return !_data
      },
      set(value) {
        this.setChallengeData({
          name: 'closed',
          value: !value,
        })
      },
    },
  },
  methods: {
    ...mapActions('challenges', [
      'setChallengeData',
      'recalcChallengeProgress',
    ]),
    setWeek(value) {
      this.currentWeek = null
      let found = this.weeks.find((x) => x.short === value)
      if (found) {
        this.currentWeek = moment(found.date.date).format('YYYY-MM-DD')
      }
      console.log('selected week', this.currentWeek)
    },
    changeWeek() {},
    async recalculate() {
      let data = {
        challenge_id: this.challenge.id,
        nWeeks: 1,
        date: this.currentWeek,
      }
      console.log('Recalculating', data)
      await this.recalcChallengeProgress(data)
      this.$emit('recalculated')
    },
    async generateReport() {
      let startDate = moment(this.summary.week.value).format('YYYY-MM-DD')
      let endDate = moment(this.summary.week.value)
        .add(7, 'days')
        .format('YYYY-MM-DD')
      let filter = `challenge_${this.challenge.id}`
      let week = 1
      let orderBy = 2
      let orderDir = 'asc'
      let url = `/challengereport?dateStart=${startDate}&dateEnd=${endDate}&showEmpty=true&filter=${filter}&nWeeks=${week}&orderBy=${orderBy}&orderDir=${orderDir}`
      window.open(url)
    },
    saveIt() {
      this.$emit('saveIt')
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-open {
  margin-left: 5px;
}
.custom-button-color {
  color: white;
}
.custom-select {
  max-width: 100px;
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}
.custom-weekof {
  border-top-left-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
  font-size: 0.875rem;
}
.form-select:focus {
  box-shadow: none !important;
}
</style>
